import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation, Types } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { useWishlistId } from '@grandvisionhq/svc-wishlist';
import ADD_TO_SHOPPING_LIST from '../operations/mutations/add-to-shopping-list.js';

const useAddToShoppingList = ({ isLoggedIn , onError , onCompleted  })=>{
    const { locale  } = useIntl();
    const [hasError, setHasError] = React.useState(false);
    const { updateWishlist  } = useWishlistId();
    // used for returning the skus for onError callback
    const currentSkus = React.useRef([]);
    const [mutation, { data: data1 , loading , error  }] = useMutation(ADD_TO_SHOPPING_LIST, {
        onError () {
            onError === null || onError === void 0 ? void 0 : onError(currentSkus.current);
        },
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    const handleOnCompleted = React.useCallback((data)=>{
        if (data.addToShoppinglist.__typename === 'AddToShoppinglistFailureResponse') {
            onError === null || onError === void 0 ? void 0 : onError(currentSkus.current);
        } else {
            if ((data === null || data === void 0 ? void 0 : data.addToShoppinglist.__typename) === 'AddToShoppinglistSuccessResponse') {
                // Only pass the id when the user is not logged in. The useWishlistId hook
                // does an additional check to verify that there is not already a wishlist id in local storage.
                updateWishlist(!isLoggedIn ? {
                    id: data.addToShoppinglist.result.id
                } : undefined);
            }
        }
        onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(data);
    }, [
        onCompleted,
        onError,
        isLoggedIn,
        updateWishlist,
        currentSkus
    ]);
    const addToShoppinglist = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(productSkus, wishlistId) {
            try {
                currentSkus.current = productSkus;
                const { data  } = yield mutation({
                    variables: {
                        input: {
                            productSkus,
                            shoppinglistId: wishlistId !== null && wishlistId !== void 0 ? wishlistId : null,
                            shoppinglistType: Types.ShoppinglistType.WISHLIST
                        }
                    }
                });
                if (data) {
                    handleOnCompleted(data);
                    /**
           * Virtual mirror is expecting a promise.resolve() in a success scenario,
           * or reject() in case of a fail.
           */ return Promise.resolve(data);
                }
            } catch (e) {
                setHasError(true);
                console.error('Error while adding a wishlist item to the shopping list', e);
            }
            return Promise.reject();
        });
        return function(productSkus, wishlistId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleOnCompleted,
        mutation
    ]);
    var ref, ref1;
    return {
        addToShoppinglist,
        loading,
        error: (ref1 = (ref = error !== null && error !== void 0 ? error : hasError) !== null && ref !== void 0 ? ref : (data1 === null || data1 === void 0 ? void 0 : data1.addToShoppinglist.__typename) === 'AddToShoppinglistFailureResponse') !== null && ref1 !== void 0 ? ref1 : null
    };
};

export { useAddToShoppingList };
//# sourceMappingURL=use-add-to-shopping-list.js.map
